var _excluded = ["AccordionProps", "AccordionDetailsProps", "AccordionSummaryProps", "children", "highlighted", "id", "label", "onClick", "SideNavMenuProps"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material';
import { IconButton } from '../../index';
import { CaretDown as CaretDownIcon } from '@mineral/icons';
import { useLeftDrawerState } from '../../AppShell';
import { States } from '../../AppShell/Drawer';
import { PrivateSideNavMenuItem } from './PrivateSideNavMenuItem';
import { SideNavMenu, useSideNavContext } from '../SideNavMenu';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Root = styled(Accordion, {
  label: 'MnrlPrivateSideNavMenuItemWithMenu-root'
})({
  backgroundColor: 'transparent',
  border: 0,
  color: 'inherit',
  margin: 0,
  position: 'static',
  transition: 'none'
});
var Summary = styled(AccordionSummary, {
  label: 'MnrlPrivateSideNavMenuItemWithMenu-summary'
})(function (_ref) {
  var _ref$ownerState = _ref.ownerState,
      split = _ref$ownerState.split,
      isDrawerOpen = _ref$ownerState.isDrawerOpen,
      theme = _ref.theme;
  return _extends({
    minHeight: 0,
    padding: 0,
    position: 'relative',
    transition: 'none',
    width: '100%'
  }, !split && {
    '&:hover .MuiListItem-root': {
      backgroundColor: theme.palette.action.hover
    }
  }, {
    '&.Mui-expanded': {
      minHeight: 'unset'
    },
    '&.Mui-focusVisible, &:focus-visible': {
      outline: 0
    }
  }, split && isDrawerOpen && {
    paddingRight: theme.spacing(5) // Spacing for the expandIconWrapper

  }, {
    '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0
    },
    // Remove MUI default styles
    '& .MuiAccordionSummary-expandIconWrapper': {
      position: 'absolute',
      alignItems: 'center',
      justifyContent: 'end',
      display: 'flex',
      right: theme.spacing(1),
      '&, &.Mui-expanded': {
        transform: 'none',
        transition: 'none'
      }
    }
  });
});
var ExpandIconLabel = styled('span', {
  label: 'MnrlPrivateSideNavMenuItemWithMenu-expandIconLabel'
})(function (_ref2) {
  var split = _ref2.ownerState.split,
      theme = _ref2.theme;
  return _extends({
    alignItems: 'inherit',
    display: 'flex',
    justifyContent: 'inherit',
    padding: parseInt(theme.spacing(1)) / 2,
    // 24px ✕ 24px, total
    width: '100%'
  }, split && {
    border: "1px solid " + theme.palette.divider,
    borderRadius: theme.shape.borderRadius
  });
});
var ExpandIconControl = styled('div', {
  label: 'MnrlPrivateSideNavMenuItemWithMenu-expandIconControl'
})(function (_ref3) {
  var level = _ref3.ownerState.level,
      theme = _ref3.theme;
  return {
    padding: 0,
    borderRadius: 0.1,
    '&.Mui-focusVisible, &:focus-visible': {
      outlineOffset: level === 1 ? theme.spacing(1) : parseInt(theme.spacing(1)) / 2,
      outlineColor: theme.palette.primary.main
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
      fontSize: theme.spacing(2),
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    '.Mui-expanded > & .MuiSvgIcon-root': {
      transform: 'rotate(180deg)'
    }
  };
});
var NavItem = styled(PrivateSideNavMenuItem, {
  label: 'MnrlPrivateSideNavMenuItemWithMenu-navItem'
})(function (_ref4) {
  var highlighted = _ref4.ownerState.highlighted,
      theme = _ref4.theme;
  return _extends({
    margin: 0
  }, highlighted && {
    // inner
    '& .MuiListItem-root': _extends({}, theme.typography.h5, {
      color: theme.palette.text.primary,
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main
      }
    })
  });
});
var Details = styled(AccordionDetails, {
  label: 'MnrlPrivateSideNavMenuItemWithMenu-details'
})({
  display: 'block',
  padding: 0
});
export var PrivateSideNavMenuItemWithMenu = /*#__PURE__*/React.forwardRef(function (_ref5, ref) {
  var _ref5$AccordionProps = _ref5.AccordionProps,
      AccordionProps = _ref5$AccordionProps === void 0 ? {} : _ref5$AccordionProps,
      _ref5$AccordionDetail = _ref5.AccordionDetailsProps,
      AccordionDetailsProps = _ref5$AccordionDetail === void 0 ? {} : _ref5$AccordionDetail,
      _ref5$AccordionSummar = _ref5.AccordionSummaryProps,
      AccordionSummaryProps = _ref5$AccordionSummar === void 0 ? {} : _ref5$AccordionSummar,
      children = _ref5.children,
      highlighted = _ref5.highlighted,
      id = _ref5.id,
      label = _ref5.label,
      _onClick = _ref5.onClick,
      _ref5$SideNavMenuProp = _ref5.SideNavMenuProps,
      SideNavMenuProps = _ref5$SideNavMenuProp === void 0 ? {} : _ref5$SideNavMenuProp,
      restProps = _objectWithoutPropertiesLoose(_ref5, _excluded);

  var _useLeftDrawerState = useLeftDrawerState(),
      drawerState = _useLeftDrawerState[0].state;

  var isDrawerOpen = drawerState !== States.Closed;

  var _useSideNavContext = useSideNavContext(),
      level = _useSideNavContext.level,
      split = _useSideNavContext.split;

  var _React$useState = React.useState(Boolean(AccordionProps == null ? void 0 : AccordionProps.defaultExpanded)),
      localExpanded = _React$useState[0],
      setLocalExpanded = _React$useState[1];

  if (process.env.NODE_ENV !== 'production') {
    if (!id) {
      console.warn('SideNavMenuItems with `children` must be provided a unique `id` for accessibility purposes');
      return null;
    }

    if (level === 3) {
      console.warn('SideNavMenuItem cannot be rendered with `children` at the tertiary level');
      return null;
    }
  }

  var DETAILS_ID = id + "-details";
  var expanded = (AccordionProps == null ? void 0 : AccordionProps.expanded) || localExpanded;
  var ownerState = {
    highlighted: highlighted,
    isDrawerOpen: isDrawerOpen,
    level: level,
    split: split
  };
  var a11yProps = {
    'aria-controls': DETAILS_ID,
    'aria-expanded': expanded,
    component: 'button'
  };
  return /*#__PURE__*/_jsxs(Root, _extends({
    elevation: 0,
    onChange: function onChange(event, expanded) {
      if ((AccordionProps == null ? void 0 : AccordionProps.expanded) === undefined) {
        setLocalExpanded(expanded);
      }

      AccordionProps.onChange && AccordionProps.onChange(event, expanded);
    },
    square: true
  }, AccordionProps, {
    // @ts-ignore
    ref: ref,
    children: [/*#__PURE__*/_jsx(Summary // @ts-ignore — [1] MUI doesn't type `null` as valid for attributes
    , _extends({
      "aria-disabled": null // @ts-ignore — [1]
      ,
      "aria-expanded": null,
      "data-testid": "sideNavMenuItemSummary",
      expandIcon: isDrawerOpen && /*#__PURE__*/_jsx(ExpandIconControl, _extends({}, split ? _extends({}, a11yProps, {
        as: IconButton,
        size: 'small',
        'aria-label': label
      }) : undefined, {
        "data-testid": "sideNavMenuItemIconButton",
        ownerState: ownerState,
        children: /*#__PURE__*/_jsx(ExpandIconLabel, {
          ownerState: ownerState,
          children: /*#__PURE__*/_jsx(CaretDownIcon, {})
        })
      })),
      id: id // @ts-ignore — [1]
      // eslint-disable-next-line jsx-a11y/aria-role
      ,
      role: null // @ts-ignore — [1]
      ,
      tabIndex: null,
      ownerState: ownerState
    }, AccordionSummaryProps, {
      children: /*#__PURE__*/_jsx(NavItem, _extends({
        label: label
      }, split ? {
        onClick: function onClick(event) {
          event.stopPropagation();
          _onClick && _onClick(event);
        }
      } : _extends({}, a11yProps, {
        onClick: _onClick
      }), {
        ownerState: ownerState
      }, restProps))
    })), /*#__PURE__*/_jsx(Details, _extends({
      id: DETAILS_ID
    }, AccordionDetailsProps, {
      children: /*#__PURE__*/_jsx(SideNavMenu, _extends({}, SideNavMenuProps, {
        children: children
      }))
    }))]
  }));
});